import apiClient from '@/services/rest-api-sms/apiClient'

const baseEndpoint = '/checklist'

export const get = async (_params) => {
  const response = await apiClient({
    method: 'GET',
    url: baseEndpoint,
    params: _params,
  })

  return response?.data
}

export const getLists = async (_params) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/lists`,
    params: _params,
  })

  return response?.data
}

export const store = async (data) => {
  const response = await apiClient({
    method: 'POST',
    url: baseEndpoint,
    data,
  })
  return response
}

export const getById = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })
  return response?.data
}

export const remove = async (data) => {
  const response = await apiClient({
    method: 'DELETE',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const update = async (id, data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/${id}`,
    data,
  })
  return response
}

export const updateMany = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}`,
    data,
  })
  return response
}

export const updateSorting = async (data) => {
  const response = await apiClient({
    method: 'PATCH',
    url: `${baseEndpoint}/update-sorting`,
    data,
  })
  return response
}
